import { ROUTES } from "../routes";

/** True when a client has MSP services (Autotask, Freshservice, NOC, or SOC). */
export const isMspClient = (client) => {
  if (!client) return true;
  if (client.is_msp_client !== undefined) return Boolean(client.is_msp_client);
  return Boolean(
    client.has_autotask ||
    client.has_freshservice ||
    client.freshservice_workspace_id ||
    client.has_noc ||
    client.has_soc
  );
};

/** Default landing page for a selected client in client or superadmin view. */
export const getClientHomeRoute = (client, { isStaff = false, isClientView = false } = {}) => {
  if (isStaff && !isClientView) {
    if (!client) return ROUTES.SUPERADMIN_OVERVIEW;
    return isMspClient(client) ? ROUTES.SUPERADMIN_OVERVIEW : ROUTES.SUPERADMIN_ENGAGEMENT;
  }
  if (!client) return ROUTES.CLIENT_OVERVIEW;
  return isMspClient(client) ? ROUTES.CLIENT_OVERVIEW : ROUTES.CLIENT_ENGAGEMENT;
};

/** True for Versetal staff who use the superadmin portal. */
export const isInternalUser = (user) => Boolean(user?.is_staff);

/** Default landing page immediately after login or when visiting `/`. */
export const getDefaultHomeRoute = (user) => {
  if (isInternalUser(user)) {
    return ROUTES.SUPERADMIN_OVERVIEW;
  }
  return getClientHomeRoute(user?.client, { isStaff: false, isClientView: true });
};

/** True when nav should be limited to Engagements for the active client. */
export const isEngagementsOnlyClient = (client) => Boolean(client && !isMspClient(client));
